import type { LegalAccount, ManagedSubAccount } from './data';

export function formatTCPAccounts(subAccounts: ManagedSubAccount[]) {
  const tcpAccounts = subAccounts.map(account => {
    return formatLegalAccountType({
      ownershipType: account.legalAccount.ownershipType,
      taxationType: account.legalAccount.taxationType,
    });
  });

  if (tcpAccounts.length === 1) {
    return tcpAccounts[0];
  }

  if (tcpAccounts.length === 2) {
    return tcpAccounts.join(' and ');
  }

  const allButLast = tcpAccounts.slice(0, -1).join(', ');
  const lastAccount = tcpAccounts.at(-1);

  return lastAccount ? `${allButLast}, and ${lastAccount}` : allButLast;
}

export function formatLegalAccountType({
  ownershipType,
  taxationType,
}: Pick<LegalAccount, 'ownershipType' | 'taxationType'>) {
  switch (taxationType) {
    case 'ROTH_401K':
      return 'Roth 401(k)';
    case 'TRADITIONAL_401K':
      return 'Traditional 401(k)';
    case 'ROTH_IRA':
      return 'Roth IRA';
    case 'TRADITIONAL_IRA':
      return 'Traditional IRA';
    case 'SEP_IRA':
      return 'SEP IRA';
    case 'HSA':
      return 'HSA';
    case 'HOLDING_529':
      return '529 Plan';
    case 'TAXABLE':
    default:
      if (ownershipType === 'JOINT') return 'Joint taxable';
      if (ownershipType === 'TRUST') return 'Trust taxable';
      return 'Individual taxable';
  }
}
